<template>
  <div
    class="count-stepper d-flex align-items-center"
    :class="{ active: value > 0 }"
  >
    <button
      type="button"
      class="step-btn"
      :disabled="disabled || value <= min"
      @click="$emit('input', value - 1)"
    >
      <i class="fa-regular fa-minus" />
    </button>
    <div
      class="count"
      :class="{ zero: value === 0 }"
    >
      {{ value }}
    </div>
    <button
      type="button"
      class="step-btn"
      :disabled="disabled"
      @click="$emit('input', value + 1)"
    >
      <i class="fa-regular fa-plus" />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    min: {
      type: Number,
      default: 0,
    },
    disabled: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.count-stepper {
  border-radius: 999px;

  // Inset outline is painted under the buttons, so their edges overlap it without a gap
  &.active {
    box-shadow: inset 0 0 0 1px $blue;
  }
}

.step-btn {
  width: 56px;
  height: 56px;
  min-width: 56px;
  border-radius: 100%;
  border: none;
  background-color: $blue;
  color: white;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 150ms;

  &:hover:not(:disabled) {
    background-color: darken($blue, 8%);
  }

  &:disabled {
    background-color: #b8d5ff;
    cursor: default;
  }
}

.count {
  width: 36px;
  text-align: center;
  font-family: "DM-Mono", monospace;
  font-size: 20px;
  font-weight: 500;

  &.zero {
    color: $light-gray;
  }
}

@media screen and (max-width: 575px) {
  .step-btn {
    width: 48px;
    height: 48px;
    min-width: 48px;
  }
}
</style>
